import type { Dispatch, SetStateAction } from "react";
import type { CreativeChoice } from "src/pages/ad-studio/insights/performance/types";
import type { EntityCardAction } from "src/pages/ad-studio/insights/performance/view/types";

export const useAdCardItemActions = ({
  setChoice,
}: {
  setChoice: Dispatch<SetStateAction<CreativeChoice>>;
}): ((action: EntityCardAction) => void) => {
  return (action) => {
    switch (action.kind) {
      case "EntityCardAction/stepped-media": {
        return setChoice(action.choice);
      }
      default: {
        return action.kind satisfies never;
      }
    }
  };
};
